var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntraUterine = function SvgIntraUterine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M33.17 14.377c.856-4.519-1.348-7.088-3.261-7.871a6.97 6.97 0 0 0-4.519-.237 17.9 17.9 0 0 1-9.984 0 7.1 7.1 0 0 0-4.519.237c-1.913.783-4.117 3.352-3.261 7.871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M11.233 6.378c7.78 0 6.523 27.622 6.523 27.622M29.544 6.378C21.764 6.378 23.022 34 23.022 34M7.626 21.629a3.626 3.626 0 1 0 0-7.252 3.626 3.626 0 0 0 0 7.251M33.17 21.629a3.626 3.626 0 1 0 0-7.252 3.626 3.626 0 0 0 0 7.251"
  })));
};
export default SvgIntraUterine;